let config = (envConfig) => ({
  api: {
    login: "/login",
    subscription: "/subscription",
    registration: "/registration",
    webform: "/webform",
    opintelUsers: "/opintel/users",
    oAuthToken: "/v2/oauth/accesstoken",
    captchaVerify: "/recaptcha/api/siteverify",
    resourceLink: "/remotestyles",
  },
  hostname: "",
  headers: {
    "Cache-Control": "no-cached, no-store",
    Pragma: "no-cache",
    Expires: "0",
  },
  timeout: 60000,
  ...envConfig,
});

export default config;
